export default __webpack_public_path__ + "static/media/blueCard.51f8b4b0.png";